var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g3, _g4, _path12, _path13, _path14, _circle, _path15, _path16, _path17, _path18, _path19, _path20, _g5, _path21, _path22, _rect, _path23, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 651,
    height: 380,
    viewBox: "0 0 651 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.304 111.489L316.123 111.489C309.653 111.489 304.547 111.489 300.435 111.825C296.238 112.168 292.718 112.881 289.515 114.513C284.294 117.174 280.049 121.418 277.389 126.64C275.757 129.843 275.043 133.362 274.7 137.56C274.364 141.671 274.364 146.778 274.364 153.248L274.364 153.429V283.57L274.364 283.752C274.364 290.222 274.364 295.328 274.7 299.439C275.043 303.637 275.757 307.156 277.389 310.36C280.049 315.581 284.294 319.826 289.515 322.486C292.718 324.118 296.238 324.831 300.435 325.174C304.547 325.51 309.653 325.51 316.123 325.51H316.304H384.696H384.877C391.347 325.51 396.453 325.51 400.565 325.174C404.762 324.831 408.282 324.118 411.485 322.486C416.706 319.826 420.951 315.581 423.611 310.36C425.243 307.156 425.957 303.637 426.3 299.439C426.636 295.328 426.636 290.222 426.636 283.752V283.57V153.429V153.247C426.636 146.777 426.636 141.671 426.3 137.56C425.957 133.362 425.243 129.843 423.611 126.64C420.951 121.418 416.706 117.174 411.485 114.513C408.282 112.881 404.762 112.168 400.565 111.825C396.453 111.489 391.347 111.489 384.877 111.489L384.696 111.489H316.304ZM293.232 121.809C295.089 120.863 297.411 120.287 301.102 119.986C304.841 119.68 309.613 119.677 316.304 119.677H384.696C391.387 119.677 396.159 119.68 399.898 119.986C403.589 120.287 405.911 120.863 407.768 121.809C411.448 123.684 414.441 126.676 416.316 130.357C417.262 132.213 417.838 134.535 418.139 138.227C418.445 141.966 418.448 146.738 418.448 153.429V283.57C418.448 290.261 418.445 295.034 418.139 298.773C417.838 302.464 417.262 304.786 416.316 306.642C414.441 310.323 411.448 313.315 407.768 315.19C405.911 316.136 403.589 316.712 399.898 317.014C396.159 317.319 391.387 317.322 384.696 317.322H316.304C309.613 317.322 304.841 317.319 301.102 317.014C297.411 316.712 295.089 316.136 293.232 315.19C289.552 313.315 286.559 310.323 284.684 306.642C283.738 304.786 283.163 302.464 282.861 298.773C282.556 295.034 282.552 290.261 282.552 283.57V153.429C282.552 146.738 282.556 141.966 282.861 138.227C283.163 134.535 283.738 132.213 284.684 130.357C286.559 126.676 289.552 123.684 293.232 121.809ZM329.917 286.447C327.656 286.447 325.823 288.28 325.823 290.541C325.823 292.802 327.656 294.635 329.917 294.635H371.083C373.344 294.635 375.177 292.802 375.177 290.541C375.177 288.28 373.344 286.447 371.083 286.447H329.917Z",
    fill: "#1674A9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 168,
    width: 180.762,
    height: 54.7668,
    rx: 6.33888,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.508,
    y: 168.508,
    width: 179.746,
    height: 53.7508,
    rx: 5.83086,
    stroke: "#F2F2F2",
    strokeWidth: 1.01605
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M453.769 201.294C453.236 201.303 452.727 201.532 452.353 201.933C451.979 202.334 451.77 202.874 451.77 203.436C451.77 203.998 451.979 204.538 452.353 204.938C452.727 205.339 453.236 205.569 453.769 205.578H475.028C475.566 205.586 476.086 205.369 476.472 204.974C476.859 204.579 477.081 204.038 477.089 203.47C477.098 202.902 476.893 202.354 476.518 201.946C476.144 201.538 475.631 201.304 475.093 201.294C475.071 201.293 475.049 201.293 475.028 201.294H453.769Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M453.769 187.79C453.236 187.802 452.727 188.11 452.353 188.648C451.979 189.186 451.77 189.91 451.77 190.664C451.77 191.419 451.979 192.143 452.353 192.681C452.727 193.219 453.236 193.527 453.769 193.539H517.727C518.266 193.55 518.785 193.259 519.172 192.728C519.559 192.198 519.781 191.472 519.789 190.71C519.798 189.949 519.592 189.213 519.218 188.666C518.844 188.118 518.331 187.803 517.793 187.79C517.771 187.789 517.749 187.789 517.727 187.79H453.769Z",
    fill: "#A6A6A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M538.328 200.903L542.319 194.704L548.306 198.758L551.157 194.704L556.859 197.804L565.696 190.412M565.696 190.412H562.275M565.696 190.412V193.75",
    stroke: "#62BF8D",
    strokeWidth: 0.874833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 147,
    y: 95,
    width: 153,
    height: 46.3555,
    rx: 5.36533,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.43,
    y: 95.43,
    width: 152.14,
    height: 45.4955,
    rx: 4.93533,
    stroke: "#F2F2F2",
    strokeWidth: 0.86
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.358 123.875C192.906 123.883 192.476 124.078 192.159 124.417C191.843 124.756 191.665 125.213 191.665 125.689C191.665 126.164 191.843 126.621 192.159 126.96C192.476 127.3 192.906 127.494 193.358 127.502H211.351C211.807 127.509 212.246 127.325 212.574 126.99C212.901 126.656 213.089 126.198 213.096 125.718C213.103 125.237 212.93 124.773 212.613 124.428C212.296 124.082 211.862 123.884 211.406 123.875C211.388 123.875 211.369 123.875 211.351 123.875H193.358Z",
    fill: "#A6A6A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.358 110.54C192.906 110.553 192.476 110.861 192.159 111.399C191.843 111.936 191.665 112.661 191.665 113.415C191.665 114.17 191.843 114.894 192.159 115.432C192.476 115.969 192.906 116.278 193.358 116.29H247.493C247.948 116.301 248.388 116.009 248.715 115.479C249.043 114.949 249.231 114.223 249.238 113.461C249.245 112.699 249.071 111.964 248.754 111.416C248.437 110.869 248.004 110.554 247.548 110.54C247.529 110.54 247.511 110.54 247.493 110.54H193.358Z",
    fill: "#A6A6A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M264.93 123.86L268.308 118.613L273.375 122.044L275.788 118.613L280.614 121.237L288.094 114.98M288.094 114.98H285.199M288.094 114.98V117.806",
    stroke: "#62BF8D",
    strokeWidth: 0.740472,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.634 117.683C158.634 110.693 164.301 105.026 171.291 105.026C178.282 105.026 183.948 110.693 183.948 117.683C183.948 124.674 178.282 130.34 171.291 130.34C164.301 130.34 158.634 124.674 158.634 117.683Z",
    fill: "#F6921A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.132 117.894C175.312 118.014 175.492 118.074 175.611 118.195C176.511 118.796 176.751 119.638 176.571 120.66C176.451 121.261 176.211 121.862 175.791 122.404C175.372 122.885 174.832 123.185 174.172 123.306C173.452 123.426 172.792 123.366 172.132 123.245C172.012 123.245 171.832 123.185 171.712 123.185C171.652 123.185 171.592 123.185 171.592 123.306C171.412 123.967 171.233 124.689 171.113 125.35C171.113 125.47 171.053 125.47 170.933 125.47C170.573 125.35 170.153 125.29 169.793 125.17C169.733 125.17 169.733 125.109 169.733 125.049C169.913 124.388 170.093 123.666 170.213 123.005C170.213 122.885 170.213 122.885 170.093 122.825C169.793 122.764 169.493 122.704 169.253 122.584C169.133 122.584 169.133 122.584 169.133 122.704C168.953 123.366 168.773 124.087 168.653 124.749C168.653 124.809 168.593 124.869 168.533 124.809C168.173 124.689 167.753 124.628 167.393 124.508C167.273 124.508 167.273 124.448 167.273 124.328C167.453 123.666 167.633 122.945 167.813 122.283C167.813 122.223 167.813 122.163 167.753 122.163C166.914 121.923 166.074 121.742 165.174 121.502C165.054 121.502 165.054 121.442 165.114 121.321C165.294 120.9 165.534 120.419 165.714 119.938C165.774 119.878 165.774 119.818 165.894 119.878C166.194 119.938 166.494 120.059 166.794 120.119C167.153 120.179 167.393 120.059 167.453 119.698C167.933 117.834 168.353 115.97 168.833 114.106C168.893 113.926 168.893 113.805 168.953 113.625C169.073 113.264 168.893 112.963 168.533 112.783C168.233 112.663 167.873 112.603 167.573 112.482C167.093 112.482 167.093 112.482 167.153 112.242C167.273 111.881 167.333 111.52 167.393 111.16C167.393 111.039 167.453 111.039 167.513 111.039C168.353 111.28 169.193 111.46 170.093 111.701C170.213 111.701 170.213 111.701 170.213 111.581C170.393 110.919 170.573 110.198 170.693 109.536C170.693 109.416 170.753 109.416 170.813 109.476C171.173 109.596 171.592 109.656 171.952 109.777C172.012 109.777 172.072 109.837 172.012 109.897C171.832 110.558 171.652 111.22 171.532 111.881C171.532 112.001 171.532 112.001 171.652 112.062C171.952 112.122 172.252 112.182 172.552 112.242C172.672 112.242 172.672 112.242 172.672 112.122C172.852 111.46 173.032 110.799 173.152 110.137C173.152 110.017 173.212 110.017 173.272 110.077C173.632 110.198 174.052 110.258 174.412 110.378C174.532 110.378 174.532 110.438 174.532 110.558C174.352 111.22 174.172 111.881 174.052 112.603C174.052 112.723 174.052 112.723 174.112 112.783C174.652 112.963 175.192 113.204 175.671 113.565C176.211 113.926 176.631 114.407 176.751 115.128C176.871 116.03 176.691 116.872 175.971 117.533C175.851 117.714 175.492 117.834 175.132 117.894ZM172.012 121.321C172.192 121.321 172.372 121.321 172.492 121.261C172.612 121.261 172.732 121.201 172.792 121.201C173.692 120.961 174.052 119.818 173.392 119.097C173.092 118.736 172.612 118.495 172.192 118.315C171.592 118.074 170.933 117.954 170.273 117.774C170.213 117.774 170.213 117.774 170.153 117.834C169.913 118.796 169.673 119.758 169.433 120.72C169.433 120.78 169.433 120.84 169.493 120.84C169.673 120.9 169.793 120.9 169.973 120.961C170.693 121.201 171.352 121.321 172.012 121.321ZM172.552 116.812C172.732 116.812 172.972 116.812 173.152 116.752C173.992 116.631 174.472 115.79 174.112 115.068C173.932 114.707 173.632 114.467 173.332 114.286C172.732 113.926 172.012 113.805 171.352 113.685C171.292 113.685 171.292 113.685 171.233 113.745C171.173 113.865 171.173 114.046 171.113 114.166C170.933 114.888 170.753 115.609 170.573 116.331C170.573 116.391 170.513 116.451 170.633 116.451C171.292 116.631 171.892 116.812 172.552 116.812Z",
    fill: "#FEFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.01 121.321C171.35 121.321 170.69 121.201 170.031 121.021C169.851 120.96 169.731 120.96 169.551 120.9C169.491 120.9 169.431 120.84 169.491 120.78C169.731 119.818 169.971 118.856 170.211 117.894C170.211 117.834 170.211 117.774 170.331 117.834C170.99 118.014 171.65 118.134 172.25 118.375C172.73 118.555 173.15 118.736 173.45 119.157C174.11 119.878 173.75 120.96 172.85 121.261C172.73 121.321 172.61 121.321 172.55 121.321C172.31 121.321 172.19 121.381 172.01 121.321Z",
    fill: "#F6921A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.55 116.812C171.891 116.812 171.291 116.631 170.691 116.451C170.631 116.451 170.631 116.391 170.631 116.331C170.811 115.609 170.991 114.888 171.171 114.166C171.231 114.046 171.231 113.865 171.291 113.745C171.291 113.685 171.291 113.685 171.411 113.685C172.071 113.865 172.79 113.986 173.39 114.286C173.75 114.467 174.05 114.707 174.17 115.068C174.47 115.79 173.99 116.631 173.21 116.752C172.91 116.812 172.73 116.812 172.55 116.812Z",
    fill: "#F6921A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.291 200.653C434.291 207.608 428.653 213.247 421.697 213.247C414.742 213.247 409.103 207.608 409.103 200.653C409.103 193.697 414.742 188.059 421.697 188.059C428.653 188.059 434.291 193.697 434.291 200.653Z",
    fill: "#1BA27A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.608 194.409H415.683V197.288H420.206V201.52H423.085V197.288H427.608V194.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.673 201.971C417.931 201.971 414.898 201.379 414.898 200.648C414.898 199.917 417.931 199.325 421.673 199.325C425.415 199.325 428.448 199.917 428.448 200.648C428.448 201.379 425.415 201.971 421.673 201.971ZM429.28 200.868C429.28 199.926 425.874 199.163 421.673 199.163C417.471 199.163 414.065 199.926 414.065 200.868C414.065 201.698 416.706 202.389 420.206 202.542V208.617H423.085V202.545C426.612 202.396 429.28 201.702 429.28 200.868Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 258,
    width: 241.762,
    height: 73.2484,
    rx: 8.478,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.6795,
    y: 258.679,
    width: 240.403,
    height: 71.8895,
    rx: 7.79854,
    stroke: "#F2F2F2",
    strokeWidth: 1.35893
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.252 282.871C144.538 282.883 143.858 283.191 143.358 283.729C142.858 284.267 142.577 284.991 142.577 285.746C142.577 286.5 142.858 287.224 143.358 287.762C143.858 288.3 144.538 288.608 145.252 288.62H230.793C231.513 288.632 232.208 288.34 232.725 287.81C233.242 287.279 233.539 286.553 233.551 285.792C233.562 285.03 233.288 284.294 232.787 283.747C232.286 283.199 231.6 282.884 230.88 282.871C230.851 282.87 230.822 282.87 230.793 282.871H145.252Z",
    fill: "#A6A6A6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.252 303.943C144.538 303.955 143.858 304.262 143.358 304.798C142.858 305.334 142.577 306.056 142.577 306.808C142.577 307.56 142.858 308.281 143.358 308.817C143.858 309.353 144.538 309.66 145.252 309.673H173.684C174.404 309.684 175.099 309.393 175.616 308.865C176.133 308.336 176.43 307.613 176.442 306.854C176.453 306.094 176.178 305.361 175.678 304.816C175.177 304.27 174.491 303.956 173.771 303.943C173.742 303.942 173.713 303.942 173.684 303.943H145.252Z",
    fill: "#A6A6A6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M258.346 303.918L263.684 295.627L271.691 301.048L275.504 295.627L283.13 299.773L294.95 289.886M294.95 289.886H290.374M294.95 289.886V294.351",
    stroke: "#62BF8D",
    strokeWidth: 1.17005,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.314,
    cy: 297.581,
    r: 20,
    fill: "#C4C4C4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.588 282.581L108.386 283.27V303.283L108.588 303.486L117.863 297.995L108.588 282.581Z",
    fill: "#343434"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.589 282.581L99.3142 297.995L108.589 303.486V293.772V282.581Z",
    fill: "#8C8C8C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M108.588 305.245L108.474 305.384V312.513L108.588 312.847L117.868 299.756L108.588 305.245Z",
    fill: "#3C3C3B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M108.588 312.847V305.245L99.314 299.756L108.588 312.847Z",
    fill: "#8C8C8C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.588 303.486L117.863 297.995L108.588 293.772V303.486Z",
    fill: "#141414"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.314 297.995L108.588 303.486V293.772L99.314 297.995Z",
    fill: "#393939"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.314 317.581C120.36 317.581 129.314 308.626 129.314 297.581C129.314 286.535 120.36 277.581 109.314 277.581C98.2683 277.581 89.3139 286.535 89.3139 297.581C89.3139 308.626 98.2683 317.581 109.314 317.581Z",
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.936 282.58V293.668L119.308 297.855L109.936 282.58Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.936 282.58L100.564 297.855L109.936 293.668V282.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.936 305.041V312.574L119.314 299.601L109.936 305.041Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.936 312.574V305.039L100.564 299.601L109.936 312.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.936 303.296L119.308 297.855L109.936 293.67V303.296Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.564 297.855L109.936 303.296V293.67L100.564 297.855Z",
    fill: "white",
    fillOpacity: 0.602
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491.477 302.147C486.356 296.909 477.929 296.909 472.808 302.147C467.847 307.22 467.847 315.327 472.808 320.401L489.754 337.732C491.34 339.355 493.951 339.355 495.537 337.732L512.483 320.401C517.444 315.327 517.444 307.22 512.483 302.147C507.362 296.909 498.935 296.909 493.814 302.147L492.646 303.342L491.477 302.147Z",
    fill: "#E3757D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.413 209.98L172.317 194.09C173.016 193.291 174.025 192.833 175.086 192.833C177.728 192.833 179.509 195.534 178.468 197.962L173.417 209.75H182.625C186.067 209.75 187.789 209.75 188.953 210.466C189.973 211.093 190.724 212.076 191.061 213.225C191.445 214.537 190.992 216.197 190.086 219.518L190.086 219.518L187.054 230.635C186.498 232.676 186.219 233.696 185.634 234.454C185.117 235.123 184.434 235.645 183.652 235.968C182.766 236.333 181.709 236.333 179.593 236.333H164.233C161.526 236.333 160.173 236.333 159.139 235.806C158.23 235.343 157.49 234.604 157.027 233.694C156.5 232.66 156.5 231.307 156.5 228.6V215.072C156.5 213.997 156.5 213.459 156.612 212.948C156.711 212.495 156.875 212.058 157.099 211.652C157.351 211.194 157.705 210.789 158.413 209.98ZM151.062 212.167C151.062 211.166 150.251 210.354 149.25 210.354C148.249 210.354 147.438 211.166 147.438 212.167V236.333C147.438 237.334 148.249 238.146 149.25 238.146C150.251 238.146 151.063 237.334 151.063 236.333L151.062 212.167Z",
    fill: "#1674A9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    transform: "translate(451 49)",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.845 77.5C455.845 64.4406 466.361 53.845 479.5 53.845C487.302 53.845 493.144 57.1053 496.991 60.311C497.569 60.7928 498.104 61.2745 498.595 61.7455V57.3125C498.595 56.0533 499.616 55.0325 500.875 55.0325C502.134 55.0325 503.155 56.0533 503.155 57.3125V68C503.155 69.2592 502.134 70.28 500.875 70.28H491.375C490.116 70.28 489.095 69.2592 489.095 68C489.095 66.7408 490.116 65.72 491.375 65.72H496.126C495.534 65.1092 494.849 64.4615 494.072 63.814C490.793 61.0822 485.948 58.405 479.5 58.405C468.889 58.405 460.405 66.9493 460.405 77.5C460.405 78.7592 459.384 79.78 458.125 79.78C456.866 79.78 455.845 78.7592 455.845 77.5ZM498.923 69.178C498.923 69.1786 498.923 69.1785 498.923 69.1777L498.923 69.178ZM500.875 75.22C502.134 75.22 503.155 76.2408 503.155 77.5C503.155 90.5643 492.564 101.155 479.5 101.155C472.806 101.155 467.532 97.7912 464.042 94.6266C463.595 94.2217 463.174 93.8171 462.78 93.4193V97.6875C462.78 98.9467 461.759 99.9675 460.5 99.9675C459.241 99.9675 458.22 98.9467 458.22 97.6875V87C458.22 85.7408 459.241 84.72 460.5 84.72H470.153C471.412 84.72 472.433 85.7408 472.433 87C472.433 88.2592 471.412 89.28 470.153 89.28H465.137C465.71 89.9105 466.367 90.58 467.105 91.2484C470.163 94.0213 474.389 96.595 479.5 96.595C490.046 96.595 498.595 88.0459 498.595 77.5C498.595 76.2408 499.616 75.22 500.875 75.22Z",
    fill: "#53AB7C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 396.009,
    y: 166.505,
    width: 186.744,
    height: 60.7483,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.49537
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.49537
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 144.469,
    y: 93.7343,
    width: 158.063,
    height: 51.4183,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.26571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.26571
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 68,
    y: 256,
    width: 249.762,
    height: 81.2484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.3141,
    height: 25.3141,
    fill: "white",
    transform: "translate(409 188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(89.3139 277.581)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkets);
export default __webpack_public_path__ + "static/media/markets.78bd1a9a9632c13e5b93c7f6d1299bdb.svg";
export { ForwardRef as ReactComponent };